module.exports = __webpack_public_path__ + "fonts/CashSans-BoldItl.5ed15d7.woff2";